import React from 'react';
import ConfirmationModal from '../../../../../Base/Components/Confirmation/ConfirmationModal';
import { BaseModalProps } from '../../../../../Base/Components/BaseModal/BaseModal';
import { useDeleteCareClaimMutation } from '../../../../../../graphql/graphql';
import useApiClient from '../../../../../Base/Hooks/useApiClient';
import useNotification from '../../../../../../Hooks/useNotification.hook';
import Button from '../../../../../../Components/Button/Button';
import { Theme } from '../../../../../../Enums/Theme.enum';

interface Props extends BaseModalProps {
	careClaimId: string;
	reloadData: () => void;
}

const ManagerInsuranceCompaniesCareClaimDeleteModal = ({
	careClaimId,
	reloadData,
	...modalProps
}: Props) => {
	const [deleteCareClaim] = useDeleteCareClaimMutation();
	const { displayGQLError } = useApiClient();
	const { showNotificationSuccess, showNotificationAlert } = useNotification();

	const handleDelete = async () => {
		try {
			const result = await deleteCareClaim({ id: careClaimId });

			displayGQLError(result);

			if ('data' in result) {
				showNotificationSuccess({
					content: 'component.reportedCare.deleteSuccess',
				});
				reloadData();
				modalProps.onClose();
			}
		} catch (error) {
			showNotificationAlert({
				content: 'base.shared.warningBug',
			});
		}
	};

	return (
		<ConfirmationModal
			{...modalProps}
			title={'component.reportedCare.deleteModalTitle'}
			text={'component.reportedCare.deleteModalText'}>
			<Button
				title={'base.shared.delete'}
				theme={Theme.RED}
				onClick={handleDelete}
			/>
		</ConfirmationModal>
	);
};

export default ManagerInsuranceCompaniesCareClaimDeleteModal;
